import React from 'react';

import { connect, useDispatch } from 'react-redux';
import { frontloadConnect } from 'react-frontload';
import { FastField, Form, Formik } from 'formik';

import ProductImages from '../ProductDetail/ProductImages';
import BreadCrumbSelector from '../../components/BreadCrumb/BreadCrumbSelector';
import { trackEvent } from '../../components/Tracking/Matomo';
import ReduxSuspense from '../../components/ReduxSuspense/ReduxSuspense';
import DealerInfo from '../../components/DealerInfo/DealerInfo';
import LegacyTireLabel from '../../components/Tires/LegacyTireLabel';

import Currency from '../../../helpers/currency';
import { taxLabel } from '../../../helpers/taxHelper';
import { speedIndexToSpeed } from '../../../helpers/tiresHelper';
import Meisterkachel from '../../components/Meisterkachel/Meisterkachel';
import Button from '../../components/form-elements/Button';
import TireInformationModal from '../../components/Tires/TireInformationModal';
import TireEnergyLabelLinks from '../Tires/TireEnergyLabelLinks';
import Anchor from '../../components/form-elements/Anchor';
import withStandortRouter from '../../components/VHost/withStandortRouter';
import { InternalLink } from '../../components/form-elements/Link';
import { addProduct } from '../../../modules/actions/standort/session/cart';
import { completeWheelResponseSelector } from '../../../modules/selectors/standort/completeWheels';
import { fetchCompleteWheelIfNeeded } from '../../../modules/actions/standort/completeWheels';

// TODO: merge/refactor with ProductDetail QuantityBox
function QuantityBox({ completeWheel, isOnline, lieferweg, price }) {
    const dispatch = useDispatch();

    function handleSubmit({ quantity }) {
        trackEvent({
            category: 'E-Commerce',
            action: 'Lege-in-Warenkorb',
            label: completeWheel.id,
            value: price * quantity * 100,
        });
        dispatch(
            addProduct({
                // TODO: validate adapter
                product: {
                    ...completeWheel,
                    isCompleteWheel: true,
                    selectedLieferweg: lieferweg,
                },
                quantity,
            })
        );
    }

    return (
        <Formik
            initialValues={{ quantity: 4 }}
            onSubmit={handleSubmit}
            render={({ values }) => (
                <Form>
                    <div className="uk-background-muted uk-padding" data-uk-margin="">
                        <div className="uk-grid-small uk-flex-middle" data-uk-grid="">
                            <div className="uk-width-1-1 uk-width-1-3@l">
                                <div className="uk-text-center">
                                    <h2 className="aps-price">
                                        <Currency quantity={price * values.quantity} />
                                    </h2>
                                    <div className="uk-text-small uk-text-muted">
                                        <div>Preis inkl. {taxLabel()} MwSt.</div>
                                        {isOnline && (
                                            <div>
                                                zzgl. etwaiger <InternalLink to="/versandkosten">Versandkosten</InternalLink>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-1 uk-width-1-3@l">
                                <div className="uk-flex uk-flex-column uk-flex-middle uk-flex-left@l">
                                    <div className="uk-grid-small uk-flex-middle" data-uk-grid="">
                                        <label className="uk-form-label" htmlFor="quantity">
                                            Menge
                                        </label>
                                        <div className="uk-form-controls">
                                            <FastField className="uk-input" name="quantity" type="number" min={1} max={1000} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="uk-width-1-1 uk-width-1-3@l uk-flex uk-flex-center">
                                <div>
                                    <Button type="submit">{isOnline ? 'Zum Warenkorb hinzufügen' : 'RESERVIEREN & ABHOLEN'}</Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            )}
        />
    );
}

function CompleteWheel({ completeWheel }) {
    const additionalCrumbs = [
        { label: 'Reifen & Felgen', url: `/reifen-felgen` },
        {
            label: 'Komplettrad',
            url: `/komplettrad`,
        },
        { label: 'Komplettradauswahl', url: `/komplettraeder` },
    ];

    return (
        <>
            <BreadCrumbSelector additionalCrumbs={additionalCrumbs} />
            <section className="uk-section uk-section-default uk-section-small">
                <div className="uk-container">
                    <h1 className="uk-margin-remove">
                        {completeWheel.reifenHersteller} {completeWheel.reifenModell}{' '}
                        <span className="uk-text-muted">{completeWheel.bezeichnung}</span> + {completeWheel.felgenHersteller}{' '}
                        {completeWheel.felgenMaterial}felge
                    </h1>
                    <h2 className="uk-text-light uk-margin-remove">{completeWheel.warengruppe}</h2>
                    <p>Artikelnummer: {completeWheel.id}</p>
                    <div className="uk-grid-small uk-child-width-1-2@s" data-uk-grid="">
                        {/* TODO: return images server-side after data source is clarified */}
                        <ProductImages variant={completeWheel} images={completeWheel.images || []} />
                        <div>
                            <div className="uk-child-width-1-1 uk-grid-small" data-uk-grid="">
                                {completeWheel.onlineLieferweg && (
                                    <QuantityBox
                                        completeWheel={completeWheel}
                                        price={completeWheel.vk_preis}
                                        lieferweg={completeWheel.onlineLieferweg}
                                        isOnline
                                    />
                                )}
                                {completeWheel.pickupLieferweg && (
                                    <QuantityBox
                                        completeWheel={completeWheel}
                                        price={completeWheel.vk_preis}
                                        lieferweg={completeWheel.pickupLieferweg}
                                    />
                                )}
                                {completeWheel.energyLabelUrl && (
                                    <div>
                                        <div className="uk-margin-small-bottom">
                                            <TireInformationModal tire={completeWheel} />
                                        </div>
                                        <div data-uk-grid="" className="uk-grid-small uk-child-width-expand@s">
                                            <TireEnergyLabelLinks tire={completeWheel} />
                                        </div>
                                    </div>
                                )}
                                <div>
                                    <table className="uk-table uk-table-striped uk-table-small">
                                        <caption>
                                            <h2>Reifen</h2>
                                        </caption>
                                        <tbody>
                                            <tr>
                                                <td className="uk-width-1-2">Hersteller</td>
                                                <td>{completeWheel.reifenHersteller}</td>
                                            </tr>
                                            <tr>
                                                <td>Profil</td>
                                                <td>{completeWheel.reifenModell}</td>
                                            </tr>
                                            <tr>
                                                <td>Größe</td>
                                                <td>{completeWheel.bezeichnung}</td>
                                            </tr>
                                            <tr>
                                                <td>Geschwindigkeitsindex</td>
                                                <td>
                                                    {completeWheel.speedindex} bis {speedIndexToSpeed[completeWheel.speedindex]} km/h
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>Loadindex</td>
                                                <td>{completeWheel.loadindex}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    <table className="uk-table uk-table-striped uk-table-small">
                                        <caption>
                                            <h2>Felge</h2>
                                        </caption>
                                        <tbody>
                                            <tr>
                                                <td className="uk-width-1-2">Hersteller</td>
                                                <td>{completeWheel.felgenHersteller}</td>
                                            </tr>
                                            <tr>
                                                <td>Material</td>
                                                <td>{completeWheel.felgenMaterial}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div>
                                    {!completeWheel.energyLabelUrl && (
                                        <ul data-uk-accordion="">
                                            <li className="uk-open">
                                                <Anchor className="uk-accordion-title">EU-Reifenlabel</Anchor>
                                                <div className="uk-accordion-content">
                                                    <LegacyTireLabel tireDetails={completeWheel} />
                                                </div>
                                            </li>
                                        </ul>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="uk-section uk-section-muted uk-section-small">
                <div className="uk-container uk-container-xsmall">
                    <Meisterkachel />
                </div>
            </section>
            <DealerInfo />
        </>
    );
}

function LoadCompleteWheel({ completeWheelResponse }) {
    return (
        <ReduxSuspense response={completeWheelResponse}>{completeWheel => <CompleteWheel completeWheel={completeWheel} />}</ReduxSuspense>
    );
}

const frontload = async props => {
    const { fetchCompleteWheelIfNeeded, completeWheelId } = props;
    await fetchCompleteWheelIfNeeded({ completeWheelId });
};

const mapDispatchToProps = { fetchCompleteWheelIfNeeded };

const mapStateToProps = (
    state,
    {
        match: {
            params: { id: completeWheelId },
        },
    }
) => {
    return { completeWheelId, completeWheelResponse: completeWheelResponseSelector(state, { completeWheelId }) };
};

export default withStandortRouter(
    connect(mapStateToProps, mapDispatchToProps)(frontloadConnect(frontload, { onUpdate: true })(LoadCompleteWheel))
);
